import { create } from 'zustand';

import { GTMState } from './types';

const FIRST_ASSIST_SHOWN_KEY = 'gtm_first_assist_shown';
const USER_PROPERTIES_SET_KEY = 'gtm_user_properties_set';

const getFirstAssistShownFromStorage = (): boolean => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(FIRST_ASSIST_SHOWN_KEY) === 'true';
};

const getUserPropertiesSetFromStorage = (): boolean => {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(USER_PROPERTIES_SET_KEY) === 'true';
};

export const useGTMStore = create<GTMState>((set) => ({
  manualDoBoxGenerated: false,
  setManualDoBoxGenerated: (value: boolean) =>
    set({ manualDoBoxGenerated: value }),
  resetManualDoBoxGenerated: () => set({ manualDoBoxGenerated: false }),
  firstAssistShown: getFirstAssistShownFromStorage(),
  setFirstAssistShown: (value: boolean) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(FIRST_ASSIST_SHOWN_KEY, String(value));
    }
    set({ firstAssistShown: value });
  },
  userPropertiesSet: getUserPropertiesSetFromStorage(),
  setUserPropertiesSet: (value: boolean) => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(USER_PROPERTIES_SET_KEY, String(value));
    }
    set({ userPropertiesSet: value });
  },
  resetUserPropertiesSet: () => {
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(USER_PROPERTIES_SET_KEY);
    }
    set({ userPropertiesSet: false });
  },
}));
